import { render } from "./DashboardView.vue?vue&type=template&id=17994510&scoped=true"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"

import "./DashboardView.vue?vue&type=style&index=0&id=17994510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17994510"]])

export default __exports__